import {
  FOC_REQUIRED_DISPOSITION,
  IOC_CARRYOVER_DISPOSITION,
} from '../orgWorkspaceTour/orgWorkspaceTourSteps';

export { FOC_REQUIRED_DISPOSITION, IOC_CARRYOVER_DISPOSITION };

export type FocPlanningPTourStepDef = {
  id: string;
  requirementId?: string;
  title: string;
  disposition?: string;
  description: string;
  bullets?: string[];
  tour?: string;
  /** 0-indexed Planning P phase to open for this step. */
  phaseIndex?: number;
  widget?: string;
  showAgenda?: boolean;
  openMeetingDetails?: boolean;
};

type RequirementInput = Omit<
  FocPlanningPTourStepDef,
  'title' | 'requirementId'
> & {
  requirementId: string;
  name: string;
};

export function focPlanningPRequirement({
  requirementId,
  name,
  ...rest
}: RequirementInput): FocPlanningPTourStepDef {
  return {
    ...rest,
    requirementId,
    title: `${requirementId} — ${name}`,
  };
}

export function focPlanningPTourNavVisible(enabled: boolean): boolean {
  return enabled;
}

export function focPlanningPTourPopoverHtml(
  step: FocPlanningPTourStepDef
): string {
  const parts: string[] = [];
  if (step.disposition) {
    parts.push(
      `<p><strong>Disposition:</strong> ${escapeHtml(step.disposition)}</p>`
    );
  }
  parts.push(`<p>${escapeHtml(step.description)}</p>`);
  if (step.bullets?.length) {
    parts.push(
      `<ul>${step.bullets
        .map((bullet) => `<li>${escapeHtml(bullet)}</li>`)
        .join('')}</ul>`
    );
  }
  return parts.join('');
}

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
